import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllFarmes();



        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

   
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' شهائد التربة  ',
            ScreenTitleSingle: ' شهادة',
            ScreenTitleSingleAl: 'الشهادة',

            Info: [],
            Statistics: [],
            FarmesSoilAnalysisInfo: [],

            AddDialog: false,

            SelectedItem:'',

            ruleForm: {
                Id: '',
                FarmesId: '',
                SampleType: '',
                Service: '',
                Company: '',
                InvoiceDate: '',
                InvoiceNumber: '',
                Price: '',
            },
            rules: {
                SampleType: this.$helper.Required(),
                Company: this.$helper.Required(),
                Service: this.$helper.Required(),
                Price: this.$helper.Required(),
            },


            ItemruleForm: {
                Id: '',
                FarmesSoilAnalysisId: '',
                Test: '',
                Symbol: '',
                Units: '',
                Results: '',
            },
            Itemrules: {
                Test: this.$helper.Required(),
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetFarmesSoilAnalysis(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.ruleForm.Price = Number(this.ruleForm.Price);

                    if (this.loginDetails.userType != 1)
                        this.ruleForm.FarmesId = Number(0);

                    if (!this.ruleForm.InvoiceDate)
                        this.ruleForm.InvoiceDate = null;

                    this.$blockUI.Start();
                    this.$http.AddFarmesSoilAnalysis(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.FarmesId = item.farmesId;
            this.ruleForm.SampleType = item.sampleType;
            this.ruleForm.Service = item.service;
            this.ruleForm.Company = item.company;
            this.ruleForm.InvoiceDate = item.invoiceDate;
            this.ruleForm.InvoiceNumber = item.invoiceNumber;
            this.ruleForm.Price = item.price;
            
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);
                    this.ruleForm.Price = Number(this.ruleForm.Price);

                    if (this.loginDetails.userType != 1)
                        this.ruleForm.FarmesId = Number(0);

                    if (!this.ruleForm.InvoiceDate)
                        this.ruleForm.InvoiceDate = null;
                    
                    this.$blockUI.Start();
                    this.$http.EditFarmesSoilAnalysis(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteFarmesSoilAnalysis(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },


        //FarmesSoilAnalysisInfo
        OpentItemDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.FarmesId = item.farmesId;
            this.ruleForm.SampleType = item.sampleType;
            this.ruleForm.Service = item.service;
            this.ruleForm.Company = item.company;
            this.ruleForm.InvoiceDate = item.invoiceDate;
            this.ruleForm.InvoiceNumber = item.invoiceNumber;
            this.ruleForm.Price = item.price;
            this.GetFarmesSoilAnalysisInfo();

        },

        GetFarmesSoilAnalysisInfo() {
            this.FarmesSoilAnalysisInfo = [];
            this.$blockUI.Start();
            this.$http.GetFarmesSoilAnalysisInfo(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.FarmesSoilAnalysisInfo = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        submitItemForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ItemruleForm.Id = Number(0);
                    this.ItemruleForm.FarmesSoilAnalysisId = this.SelectedItem.id;

                    this.$blockUI.Start();
                    this.$http.AddFarmesSoilAnalysisInfo(this.ItemruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetFarmesSoilAnalysisInfo();

                            this.ClearForm(this.ItemruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        DeleteItem(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteFarmesSoilAnalysisInfo(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },
        


    }
}
